import { render } from "./ForWhomSect.vue?vue&type=template&id=67abd1c3&ts=true"
import script from "./ForWhomSect.vue?vue&type=script&lang=ts"
export * from "./ForWhomSect.vue?vue&type=script&lang=ts"

import "./ForWhomSect.vue?vue&type=style&index=0&id=67abd1c3&lang=scss"

import exportComponent from "/Users/damodar/Documents/PROGRAMMING/STUDING/everypay/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__